import { FermeService } from './ferme.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { throwError } from 'rxjs';
import { Tache } from '../models/tache.model';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'access_token',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class TacheService {
    baseUrl: string = environment.apiUrl;

    constructor(private httpClient: HttpClient, private fermeService : FermeService) { }

    get_taches() {
        return this.httpClient.get(this.baseUrl + '/tache');
    }

    get_tachesBySalle(salle:string) {
      return this.httpClient.get(this.baseUrl + '/tache/getTachesBySalleFerme/'+ salle +'/'+ this.fermeService.selectedFerme.id)
      .catch((error: any) => {
        return throwError(error);
      });
    }

    update_tache(tache: Tache) {
      return this.httpClient.put<Tache>(this.baseUrl + '/tache/update/' + tache['tache_id'], tache, httpOptions)
      .catch((error: any) => {
        return throwError(error);
      });
    }
}